import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-121e07ff"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "wrapper-create-tags"
}
const _hoisted_2 = { class: "container-tags" }
const _hoisted_3 = {
  key: 0,
  class: "container-tags-rows"
}
const _hoisted_4 = { class: "container-tag" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "container-tag-controls" }
const _hoisted_7 = {
  key: 0,
  class: "error-field"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "add-tag-submit",
  type: "submit",
  value: "+"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderCircle = _resolveComponent("LoaderCircle")!
  const _component_PencilIcon = _resolveComponent("PencilIcon")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_XCircleIcon = _resolveComponent("XCircleIcon")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_LoaderCircle, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.tags.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tag,
                    class: "container-tag-row"
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", null, [
                        (_ctx.editMode && _ctx.tagToEdit === tag)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              class: "edit-tag",
                              id: "edit-tag-field",
                              type: "text",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.edittedTagName) = $event)),
                              maxlength: "30",
                              autofocus: ""
                            }, null, 512)), [
                              [_vModelText, _ctx.edittedTagName]
                            ])
                          : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(tag.name), 1))
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        (!_ctx.editMode || _ctx.tagToEdit !== tag)
                          ? (_openBlock(), _createBlock(_component_PencilIcon, {
                              key: 0,
                              onClick: ($event: any) => (_ctx.editTag(tag))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (!_ctx.editMode || _ctx.tagToEdit !== tag)
                          ? (_openBlock(), _createBlock(_component_TrashIcon, {
                              key: 1,
                              onClick: ($event: any) => (_ctx.removeTag(tag))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.editMode && _ctx.tagToEdit === tag)
                          ? (_openBlock(), _createBlock(_component_CheckIcon, {
                              key: 2,
                              onClick: ($event: any) => (_ctx.saveEditted(tag))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.editMode && _ctx.tagToEdit === tag)
                          ? (_openBlock(), _createBlock(_component_XCircleIcon, {
                              key: 3,
                              onClick: _ctx.cancelEditTag
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("form", {
                  id: "form-add-tag",
                  onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addTag && _ctx.addTag(...args)), ["prevent"]))
                }, [
                  _withDirectives(_createElementVNode("input", {
                    id: "add-tag-name",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newTagName) = $event)),
                    onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.detectDuplicates && _ctx.detectDuplicates(...args))),
                    type: "text",
                    placeholder: "Tag name",
                    maxlength: "30",
                    required: ""
                  }, null, 544), [
                    [_vModelText, _ctx.newTagName]
                  ]),
                  _hoisted_8
                ], 32)
              ])
            ]),
            _: 1
          })
        ])
      ]))
}